import type { SanityPageBuilderNewsletterSection, SanityPageBuilderSection } from "@ouster/shared";
import { NewsletterBlockView } from "~/features/blocks/inventory/newsletter";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderNewsletterSection;
  };
};
export function SanityNewsletterSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  return <NewsletterBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}